import $ from 'jquery'
export default function () {
	if (!$('.p-footer__arrow.c-icon--footer-arrow').length) return;
	$('.p-footer__arrow.c-icon--footer-arrow').on('click', function () {
		$('.m-footer-fixed-box.p-footer,.l-footer,.p-footer__arrow.c-icon--arrow,.top__footer').toggleClass('is-active');
	});
};